import React, {useState, useEffect} from 'react';
import post from '../utils/post.js';
import AppHeader from '../components/AppHeader.js';
import Search from '../components/Search.js';

const getMessageReadLabel = (item) => {
	if (item.READED === 0 || item.READED === '0' || !item.READEDDT) {
		return 'Nepřečteno';
	}

	return item.READEDDT;
};

export default function Message({usrInfo, timerCnt}) {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState([]);
	const [searchValue, setSearchValue] = useState('');
	const [offset, setOffset] = useState(0);
	const [loadedCnt, setLoadedCnt] = useState(0);

	useEffect(() => {
		getData('', offset);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const loadNext = () => {
		setOffset((prevOffset) => {
			let newOffset = prevOffset + usrInfo.LIST_ROWS;
			getData(searchValue, prevOffset + usrInfo.LIST_ROWS);
			return newOffset;
		});
	};

	const onChangeSearch = (value) => {
		setSearchValue(value);
		setOffset(0);
		getData(value, 0);
	};

	const getData = (search, offset) => {
		setLoading(true);

		post('getListMessagesUsr', {search: search, offset: offset})
			.then((res) => {
				if (offset === 0) {
					setData(res.data);
				} else {
					setData((prevRows) => {
						const updatedRows = [...prevRows, ...res.data];
						return updatedRows;
					});
				}

				setLoadedCnt(res.data.length);

				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const handleReaded = (ID) => {
		post('saveMessagesUsrReaded', {ID: ID})
			.then((res) => {
				setData((prevRows) => {
					const updatedRows = prevRows.map((item, idex) => {
						if (item.ID === ID) {
							item.READED = 1;
						}

						return item;
					});

					return updatedRows;
				});
			})
			.catch((error) => {
				console.error(error);
			});
	};

	const list = data.map((item, index) => {
		const isUnread = parseInt(item.READED) !== 1;

		return (
			<div className="message-page__card" key={item.ID || index}>
				<div className="message-page__card-head">
					<div className="message-page__card-meta">
						<div className="message-page__card-date">{item.CRDTS}</div>
						<div className={`message-page__card-status${isUnread ? ' is-unread' : ''}`}>Přečteno: {getMessageReadLabel(item)}</div>
					</div>
				</div>
				<div className="message-page__card-body txt_l">
					<span dangerouslySetInnerHTML={{__html: item.NOTE}} style={{wordWrap: 'break-word'}}></span>
				</div>
				{isUnread ? (
					<div className="message-page__card-actions">
						<button
							type="button"
							className="button small message-page__button"
							onClick={() => {
								handleReaded(item.ID);
							}}
						>
							Rozumím
						</button>
					</div>
				) : (
					''
				)}
			</div>
		);
	});

	return (
		<>
			<div className="page_main">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={loading} />
				<Search showSearch searchValue={searchValue} onChangeSearch={(e) => onChangeSearch(e)}></Search>

				<div className={`page message-page${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					<div className="message-page__list">
						{list.length > 0 ? list : <div className="message-page__empty">Žádné zprávy nebyly nalezeny.</div>}
					</div>

					<div className="message-page__load-more">
						{parseInt(loadedCnt) === parseInt(usrInfo.LIST_ROWS) ? (
							<button className="button small loadNext message-page__button" onClick={() => loadNext()}>
								Načíst další
							</button>
						) : (
							<span className="fnt_12 loadNext message-page__load-all">Byly načteny všechny záznamy</span>
						)}
					</div>
				</div>
			</div>
		</>
	);
}
